import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_50_0 = () => {
  return (
    <div>
      <PageTitle title='3.50.0' />

      <ParaTitle paraTitle='Server Migration & Comment Interface' />
      <Paragraph paragraph='2026-04-30' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Ability to View Drafts
          <p>Risk managers and higher roles can view draft content before it is finalized. This helps them understand what information is included and reduces hesitation around deleting drafts, since they can assess potential data loss before taking action.</p>
        </li>
        {/* <li>
          <p></p>
        </li> */}
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Server AWS Migration
          <p>Upgrading EC2 instances from 2.0 to 2.1 ensures the environment runs on the latest Ubuntu version, providing improved security patches, better performance, and compatibility with newer packages and tools.</p>
        </li>

        <li>One Approver Exception
          <p>For facilities with only one approver, approvals are automatically routed to that user without requiring approver selection. This simplifies the workflow and reduces unnecessary UI steps for single-approver setups.</p>
        </li>

        <li>Able to Sort Comments by Datetime
          <p>Add sorting options for comments so users can reorder them (e.g., newest first). This makes it easier to view the most recent updates without scrolling through the entire comment list.</p>
        </li>

        <li>Prevent Event Deletion by Users
          <p>Prevent organization managers from permanently deleting events by mistake, especially hard deletes that remove all backups. This reduces the risk of irreversible data loss due to unintended actions.</p>
        </li>

        <li>Comment User Interface Modifications 
          <p>Improve the event answers page by removing comments, reducing icon sizes, and increasing the maximum message count. These changes simplify the interface and make it easier for users to interact and leave feedback on events.</p>
        </li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
        Server Duo Issue
          <p>Resolved the server Duo authentication issue, restoring login access. This improves overall system security by ensuring two-factor authentication is properly enforced.</p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.51.0', link: '/updates/3.51.0' },
          next: { name: 'Updates: 3.49.0', link: '/updates/3.49.0' }
        }}
      />
    </div>

  )
}

export default Updates_3_50_0;